<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body p-t-0 p-b-0">
        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label for="manager" class="control-label col-form-label">Responsabile</label>
              <ng-multiselect-dropdown required [settings]="utentidropdownSettings" [placeholder]="'Seleziona'" name="manager"
                [data]="managers" [(ngModel)]="managerselezionati"  (onFilterChange)="filtroResponsabile($event)" (ngModelChange)="refreshTable()">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="inizio" class="control-label col-form-label">Inizio</label>
              <input id="inizio" required [(ngModel)]="filtri.inizio" (ngModelChange)="refreshTable()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="fine" class="control-label col-form-label">Fine</label>
              <input id="fine" required [(ngModel)]="filtri.fine" (ngModelChange)="refreshTable()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="manager" class="control-label col-form-label">Comune</label>
              <ng-multiselect-dropdown [settings]="comunidropdownSettings" [placeholder]="'Seleziona'" name="comuni"
                [data]="comuni" [(ngModel)]="comuniselezionati" (onFilterChange)="filtroComune($event)" (ngModelChange)="refreshTablebycomune()">
              </ng-multiselect-dropdown>
            </div>
          </div>

            <div class="d-flex justify-content-end p-4">
              <button type="submit" (click)="vistaGiornaliera()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Vista Giornaliera </span>
                <i-feather name="eye" class="feather-sm "></i-feather>
              </button>
            </div>


          <div class="col-lg-12 d-flex justify-content-end align-items-center">
            <div class="form-group">
              <span class="badge badge-info badge-pill font-weight-bold font-14">&nbsp;</span>
              &nbsp;
              <label for="selezionati" class="control-label col-form-label">Selezionati </label>
              &nbsp;
              <input id="selezionati" [(ngModel)]="selezionati" (ngModelChange)="VisibilityChange()"  type="checkbox">
            </div>
            &nbsp;
            &nbsp;
            <div class="form-group">
              <span class="badge badge-success badge-pill font-weight-bold font-14">&nbsp;</span>
              &nbsp;
              <label for="programmatiData" class="control-label col-form-label">programmatiData</label>
              &nbsp;
              <input id="programmatiData" [(ngModel)]="programmatiData" (ngModelChange)="VisibilityChange()"  type="checkbox">
            </div>
            &nbsp;
            &nbsp;
            <div class="form-group">
              <span class="badge badge-warning badge-pill font-weight-bold font-14">&nbsp;</span>
              &nbsp;
              <label for="programmati" class="control-label col-form-label">programmati </label>
              &nbsp;
              <input id="programmati" [(ngModel)]="programmati" (ngModelChange)="VisibilityChange()"  type="checkbox">
            </div>
            &nbsp;
            &nbsp;
            <div class="form-group">
              <span class="badge badge-pill font-weight-bold font-14" style="background-color: palevioletred;">&nbsp;</span>
              &nbsp;
              <label for="programmatiAltrui" class="control-label col-form-label">programmatiAltrui</label>
              &nbsp;
              <input id="programmatiAltrui" [(ngModel)]="programmatiAltrui" (ngModelChange)="VisibilityChange()"  type="checkbox">
            </div>
            &nbsp;
            &nbsp;
            <div class="form-group">
              <span class="badge badge-light badge-pill font-weight-bold font-14">&nbsp;</span>
              &nbsp;
              <label for="altrui" class="control-label col-form-label">altrui</label>
              &nbsp;
              <input id="altrui" [(ngModel)]="altrui" (ngModelChange)="VisibilityChange()"  type="checkbox">
            </div>
            &nbsp;
            &nbsp;
            <div class="form-group">
              <span class="badge badge-danger badge-pill font-weight-bold font-14">&nbsp;</span>
              &nbsp;
              <label for="inlista" class="control-label col-form-label">inlista </label>
              &nbsp;
              <input id="inlista" [(ngModel)]="inlista" (ngModelChange)="VisibilityChange()"  type="checkbox">
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<div class="row p-0" style="height: 100%;">
  <div class="col-4">
    <div class="card">
      <div class="card-body">
        <div class=" p-3 d-flex justify-content-end align-items-center">
          <span class="badge badge-pill font-weight-bold font-14" style="background-color: rgba(0, 151, 19, 1);"> &nbsp;</span> <span class="text-dark font-14">&nbsp;6 Mesi&nbsp;&nbsp;</span>
          <span class="badge badge-pill font-weight-bold font-14" style="background-color: rgba(0, 19, 151, 1);"> &nbsp;</span><span class="text-dark font-14">&nbsp;12 Mesi&nbsp;&nbsp;</span>
          <span class="badge badge-pill font-weight-bold font-14" style="background-color: rgba(151, 151, 19, 1);"> &nbsp;</span><span class="text-dark font-14">&nbsp;Garanzia&nbsp;&nbsp;</span>
          <span class="badge badge-pill font-weight-bold font-14" style="background-color: rgba(151, 0, 19, 1);">&nbsp;</span><span class="text-dark font-14">&nbsp;Intervento a pagamento&nbsp;&nbsp;</span>
        </div>
        <div class="table-responsive">
          <table class="table bg-white table-hover align-middle mb-0 ">
            <thead>

            </thead>
            <tbody>
              <tr *ngFor="let item of Interventi" [ngStyle]="{'background-color': item.bgcolor}"><!--| slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">-->
                  <td (click)="listClick(item)" >
                    {{item.nome}} <br>
                    <span *ngIf="item.data_fine_prevista" >{{item.data_inizio_effettiva | date: 'dd/MM/yyyy'}}</span>
                    <span *ngIf="!item.data_fine_prevista" >{{item.data_inizio_prevista | date: 'dd/MM/yyyy'}}</span> <br>
                    {{item.clienteObject.nominativo}} <br>
                    {{item.sedeObject.fullAddress}} <br>
                    {{item.sedeObject.distanza || 0 }} Km <br>
                    <span *ngIf="item.data_fine_prevista" >Già pianificato</span>
                  </td>
                  <td class="align-middle" >
                    <a href="javascript:void(0)" placement="bottom" ngbTooltip="Centra" class="link font-16 text-dark font-medium mr-2 align-middle" (click)='centra(item)'>
                      <i-feather name="map-pin" class="feather-sm"></i-feather>
                    </a>
                  </td>
                  <td class="align-middle">
                      <input id="selected" [(ngModel)]="item.selected" (ngModelChange)="onSelect(item)"  type="checkbox">
                  </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-8"  >
    <div class="card"  style="height: 600px;">
      <div class="card-body" style="height: 100%;">
        <app-mappa [centerMaplat]="centerMaplat" [centerMaplon]="centerMaplon" [markers]="Markers" [circle]="circleMarker" (onCircleMarkerChange)="refreshTable()" (onMarkerClick)="onMarkerClick($event)"></app-mappa>
      </div>
    </div>
  </div>
</div>
<!-- <div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body  ">
        <div class="row">
          <div class="col-lg-2">
            <div class="form-group">
              <input id="piaificazione" #dataPianificazione="ngModel" required [(ngModel)]="piaificazione" class="form-control"
                type="datetime-local">
                <small class="form-text text-danger" *ngIf="!dataPianificazione.valid && (dataPianificazione.dirty || dataPianificazione.touched || submitted)">Data di pianificazione richiesta!</small>
            </div>
          </div>
          <div class="col-lg-2 ">
            <button type="button" class=" btn btn-cyan rounded-pill py-2" (click)='save(dataPianificazione)'><i
                class="fas fa-save  font-14 mr-1 text-white"></i>
              <span class="ml-1 text-white font-weight-bold">salva</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- <aside class="customizer"  >
  <div style="position: absolute; bottom: 20px; left: -400px; ">
    <div class="d-md-flex align-items-center">

        <input id="piaificazione" #dataPianificazione="ngModel" required [(ngModel)]="piaificazione" class="form-control"
          type="datetime-local">
          <small class="form-text text-danger" *ngIf="!dataPianificazione.valid && (dataPianificazione.dirty || dataPianificazione.touched || submitted)">Data di pianificazione richiesta!</small>

      &nbsp;
      <button type="button" class=" btn btn-cyan rounded-pill " (click)='save(dataPianificazione)'><i
        class="fas fa-save  font-14 mr-1 text-white"></i>
        <span class="ml-1 text-white font-weight-bold">salva</span>
      </button>
    </div>
  </div>
</aside> -->

<aside class="customizer"  >
  <div style="position: absolute; bottom: 20px; left: -350px; ">
    <div class="d-md-flex align-items-center">
      <div class="ml-auto">
        <input id="piaificazione" #dataPianificazione="ngModel" required [(ngModel)]="piaificazione" (ngModelChange)="dataPianificazioneCambiata()" class="form-control"
          type="datetime-local">
          <small class="form-text text-danger" *ngIf="!dataPianificazione.valid && (dataPianificazione.dirty || dataPianificazione.touched || submitted)">Data di pianificazione richiesta!</small>
      </div>
      &nbsp; &nbsp; &nbsp;
      <button type="submit" (click)="save(dataPianificazione)" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-sm "></i-feather>
      </button>
    </div>
  </div>
</aside>


<!-- <button type="submit" (click)="newSubOfferta()"
        class="ml-auto btn btn-rounded btn-dark p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Aggiungi SottoOfferta
          <i class="mdi mdi-table-row-plus-after"></i></span>
      </button> -->
